import * as React from "react";
import { useEffect } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Container } from "@mui/material";
import NtnForm from "./NtnForm";
import { Field, Form } from "react-final-form";
import { shipmentInfoStart } from "../../state/actions/ShipmentAction";
import { ActionTypes } from "../../state/constantes/ActionTypes";
import { connect } from "react-redux";
import {
  shipmentInfoByUserStart,
} from "../../state/actions/ShipmentByUserAction";
import { portsStart } from "../../state/actions/PortsAction";
import PortList from "./PortList";
import { extractUrlParams } from "../../../../common/utils/Utils";
import "../../style/style.css";

function SearchForm(props) {
  const [eta, setEta] = React.useState(new Date()); // momentjs
  const [etd, setEtd] = React.useState(new Date());
  const [ports, setPorts] = React.useState([]);

  useEffect(() => {
    let action = shipmentInfoByUserStart({
      type: ActionTypes.ACTION_SHIPMENT_BY_USER_START,
      payload: props.params,
    });

    props.dispatch(action);
  }, []);

  useEffect(() => {
    let actionPorts = portsStart({
      type: ActionTypes.ACTION_PORTS_START,
      payload: extractUrlParams(window.location.href),
    });
    props.dispatch(actionPorts);
  }, []);

  function handleReset() {
    window.location.reload();
  }

  function handleRetour() {
    window.location.reload();
  }

  return (
    <Container style={{ padding: "0", margin: "0" }}>
      <Form
        onSubmit={(formObj) => {
          let action = shipmentInfoStart({
            type: ActionTypes.ACTION_SHIPMENT_START,
            payload: formObj,
          });
          props.dispatch(action);
        }}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <NtnForm
              inputs={[
                <Field name={"numConteneur"}>
                  {({ input }) => (
                    <TextField
                      required={true}
                      id="numConteneur"
                      name="numConteneur"
                      label="Numéro de conteneur"
                      fullWidth
                      variant="standard"
                      {...input}
                    />
                  )}
                </Field>,
                <Field name={"port"}>
                  {({ input }) => <PortList portList={props.portList} />}
                </Field>,
                <Field name={"numReservation"}>
                  {({ input }) => (
                    <TextField
                      id="numReservation"
                      name="numReservation"
                      label="Numéro de réservation"
                      autoComplete="given-name"
                      variant="standard"
                      fullWidth
                      {...input}
                    />
                  )}
                </Field>,
                <Field name={"numConnaissement"}>
                  {({ input }) => (
                    <TextField
                      id="numConnaissement"
                      name="numConnaissement"
                      label="Numéro de connaissement"
                      autoComplete="given-name"
                      variant="standard"
                      fullWidth
                      {...input}
                    />
                  )}
                </Field>,
                <Field name={"ETA"}>
                  {({ input }) => (
                    <TextField
                      fullWidth
                      id="date"
                      label="ETA"
                      type="date"
                      format={"YYYY-MM-DD"}
                      value={eta}
                      margin="normal"
                      onChange={(newValue) => {
                        setEta(newValue);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...input}
                    />
                  )}
                </Field>,
                <Field name={"ETD"}>
                  {({ input }) => (
                    <TextField
                      fullWidth
                      id="date"
                      label="ETD"
                      type="date"
                      format={"YYYY-MM-DD"}
                      value={etd}
                      margin="normal"
                      onChange={(newValue) => {
                        setEtd(newValue);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...input}
                    />
                  )}
                </Field>,
              ]}
            />
            <Stack
              direction="row"
              spacing={4}
              style={{
                padding: 10,
                marginBottom: 30,
                alignItems: "flex-end",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <button
                className="button"
                type="reset"
                onClick={() => handleReset()}
              >
                Annuler <i className="fa fa-times"></i>
              </button>
              <button className="button" type={"Submit"}>
                Chercher <i class="fa fa-search"></i>
              </button>
            </Stack>
          </form>
        )}
      </Form>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return { ...state, portList: state.PortsReducer };
};

export default connect(mapStateToProps, null)(SearchForm);
